module.exports = __webpack_public_path__ + "static/media/plus_.0504576e.svg";